<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-main">
        <NfseNacionalCreateUpdate :formName="panel.formName" />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>
import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import NfseNacionalCreateUpdate from '../../../components/modules/tax-document/nfse-nacional/NfseNacionalCreateUpdate.vue';

export default {
  name: "NfseCreateUpdateView",
  components: {
    ViewTemplateWithSalveCancel,
    NfseNacionalCreateUpdate
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Nota Fiscal",
        title: "Nfse Nacional",
        formName: "nfseCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
};
</script>
